import { BackTop } from "../class/backTop";

document.querySelectorAll('#topButton').forEach(element => { 
    new BackTop(document.querySelector('#topButton'), {
        type: "slide--bottom"  // slide--bottom, slide--right, zoom, fade
    })
});
